import { handleActions } from '@gef-ui/utils/fsaActions';
import always from "ramda/es/always";
import assoc from "ramda/es/assoc";
import flip from "ramda/es/flip";
import identity from "ramda/es/identity";
import mergeRight from "ramda/es/mergeRight";
import o from "ramda/es/o";
import prop from "ramda/es/prop";
import useWith from "ramda/es/useWith";
import { appContextActions } from '../../constants';
const tokenReducer = o(flip(useWith)([
    identity,
    prop('payload')
]), o(flip, assoc));
const mergeAppContextReducer = {
    next (state, action) {
        return mergeRight(state, action.payload);
    }
};
const pendingReducer = {
    next (state, action) {
        return assoc('isAccessTokenPending', action.payload, state);
    }
};
const initialState = {
    isAccessTokenPending: false
};
const appContextActionMap = {
    [appContextActions.UPDATE_ACCESS_TOKEN]: tokenReducer('accessToken'),
    [appContextActions.UPDATE_REFRESH_TOKEN]: tokenReducer('refreshToken'),
    [appContextActions.MERGE_APP_CONTEXT]: mergeAppContextReducer,
    [appContextActions.SET_IS_PENDING]: pendingReducer,
    [appContextActions.CLEAR_APP_CONTEXT]: always(initialState)
};
export default handleActions(appContextActionMap, initialState);
